import { get, post } from '../../../../api/index';
export const info = params => get(`/api/survey/v1/info`, params); // 问卷详情
export const addrespondence = params => post(`/api/survey/v1/addrespondence`, params); //问卷作答
